import AxiosClient from "../../../services/axios.services";

class MatrixNineBoxesServices {
  getMatrixNineBoxes = (params) =>
    AxiosClient.get("/api/app/capacitacion_matriz_9_caja/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getMatrixNineBox = (id) =>
    AxiosClient.get(`/api/app/capacitacion_matriz_9_caja/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveMatrixNineBoxes = (data) =>
    AxiosClient.post("/api/app/capacitacion_matriz_9_caja/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editMatrixNineBoxes = (id, data) =>
    AxiosClient.put(`/api/app/capacitacion_matriz_9_caja/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteMatrixNineBoxes = (id) =>
    AxiosClient.delete(`/api/app/capacitacion_matriz_9_caja/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
  saveOrderingboxes = (data) =>
    AxiosClient.post("/api/app/ordenamiento_9cajas/", data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new MatrixNineBoxesServices();
